import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import CustomTable from 'components/CustomTable';
import usePostApprovalData from 'hooks/usePostApprovalData';
import { useSelector, useDispatch } from 'react-redux';
import PostApprovalColumnButton from 'components/ColumnSelectButton/PostApprovalColumnButton';
import CustomButton from 'components/CustomInput/Button';
import CustomPagination from 'components/CustomPagination';
import TextHeader from 'components/CustomText/TextHeader';
import SideBar from './SideBar';
import DetailDrawer from './DetailDrawer';
import PageSize from 'components/CustomTable/PageSize';
import Filter from 'components/CustomTable/Filter';
import { GET_POST_APPROVAL_ZIP, POST_APPROVAL_LIST_FETCH_WITH_CANCEL, SET_POST_APPROVAL } from 'store/key';
import { useLocation } from 'react-router';
import { KEYS, getItem, setItem } from 'storage';
import usePrevious from 'hooks/usePrevious';
import { setGlobalLoading } from 'store/global/reducer';
import { DRAFT } from 'utility/lookup';
import useQuery from 'hooks/useQuery';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const SLayout = styled.div`
    min-height: 100%;
    display: flex;
`;

const SHeader = styled.div`
    font-weight: bold;
    display: flex;
    justify-content: space-between;
`;

const STableContent = styled.div`
    padding: 10px 10px 0 10px;
    flex-grow: 1;
`;

const STitle = styled.div`
    margin-top: 10px;
`;

const SColumnButton = styled.div`
    margin-top: 20px;
    display: flex;
`;

const SFilterLayout = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 10px 0;
`;

export default function PostApprovalLayout({ name }) {
    const location = useLocation();
    const history = useHistory();
    const folder = location.pathname.split('/post-approval-document/')?.[1];

    const [displayItem, setDisplayItem] = useState(null);
    const { columns, rows } = usePostApprovalData({ setDisplayItem, folder });
    const [selectedRows, setSelectedRows] = useState([]);

    const dispatch = useDispatch();
    const [isFullViewShow, setFullViewShow] = useState(false);
    const [filterKeyword, setFilterKeyword] = useState('');
    const queryPage = useQuery('page');

    const isLoading = useSelector((state) => state.postApproval.isLoading);
    const total = useSelector((state) => state.postApproval.total);

    const prevFolder = usePrevious(folder);
    const amendPage = getItem(KEYS.AMEND_PAGE);
    const amendPageSize = getItem(KEYS.AMEND_PAGE_SIZE);
    let newPage = useSelector((state) => state.postApproval.page);
    let newPageSize = useSelector((state) => state.postApproval.pageSize ?? 10);
    const page = amendPage ? Number(amendPage) : newPage ?? 1;
    const pageSize = amendPageSize ? Number(amendPageSize) : newPageSize ?? 10;

    const sort = useSelector((state) => state.postApproval.sort ?? 'updateDtm');
    const isDesc = useSelector((state) => state.postApproval.isDesc ?? true);

    const getFilterResultApplication = (rows = []) => {

        // disable checkbox selection when the status is draft
        rows.forEach((item) => {
            if (item.statusId === DRAFT) {
                item.disabledItemCheckbox = true;
            }
        });

        if (!filterKeyword) {
            return rows;
        }

        let filtered = rows.filter((item) => {
            let isFiltered = false;

            Object.values(item).forEach((value) => {
                if (typeof value === 'string') {
                    if (value.toLowerCase().includes(filterKeyword.toLowerCase())) {
                        isFiltered = true;
                    }
                }
            });

            return isFiltered;
        });

        return filtered;
    };

    const handleRefresh = () => {
        loadList({ page, pageSize });
        // setSelectedRows([]);
    };

    useEffect(() => {
        if (folder !== prevFolder) {
            if (!amendPage && !amendPageSize && (page !== 1 || pageSize !== 10)) {
                dispatch({
                    type: SET_POST_APPROVAL,
                    payload: {
                        page: 1,
                        pageSize: 10,
                    },
                });
                loadList({ page: 1, pageSize: 10 });
            } else {
                loadList({ page, pageSize });
            }
        }
        // eslint-disable-next-line
    }, [folder, prevFolder]);

    const loadList = ({ page = 1, pageSize = 10 }) => {
        if (amendPage || amendPageSize) {
            setItem(KEYS.AMEND_PAGE, '');
            setItem(KEYS.AMEND_PAGE_SIZE, '');
        }

        if (queryPage) {
            page = parseInt(queryPage);
            history.push(location.pathname);
        }

        dispatch({
            type: POST_APPROVAL_LIST_FETCH_WITH_CANCEL,
            payload: {
                page: page,
                pageSize: pageSize,
                sort,
                isDesc,
                folder: folder === 'all' ? '' : folder,
            },
        });
    };

    return (
        <SLayout>
            <STableContent>
                <SHeader>
                    <STitle>
                        <TextHeader>Post Approval List</TextHeader>
                    </STitle>
                </SHeader>

                <DetailDrawer
                    onFullViewShow={(isShow) => setFullViewShow(isShow)}
                    isShow={isFullViewShow}
                    onClose={() => setFullViewShow(false)}
                />
                <SColumnButton>
                    <PostApprovalColumnButton />
                    <CustomButton style={{ marginLeft: 30 }} onClick={handleRefresh}>
                        Refresh
                    </CustomButton>
                    <CustomButton
                        style={{ marginLeft: 30 }}
                        disabled={selectedRows?.length <= 0}
                        onClick={() => {
                            setGlobalLoading(true);

                            dispatch({
                                type: GET_POST_APPROVAL_ZIP,
                                payload: {
                                    docType: selectedRows[0].docType,
                                    docId: selectedRows[0].id,
                                    final: () => setGlobalLoading(false),
                                },
                            });
                        }}
                    >
                        Download Post Approval Document
                    </CustomButton>
                </SColumnButton>

                <SFilterLayout>
                    <Filter onChange={(value) => setFilterKeyword(value)} />
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10 }}>
                        <PageSize
                            label="Page Size"
                            value={pageSize}
                            onChange={(value) => {
                                loadList({ pageSize: value });
                            }}
                        />
                    </div>
                </SFilterLayout>

                <CustomTable
                    isCheckboxEnable
                    disabledHeaderCheckbox
                    disabledItemCheckbox={selectedRows.length > 0}
                    onRowSelected={(rows) => {

                        console.log('121950 index.jsx ', rows)

                        setSelectedRows(rows);
                    }}
                    loading={isLoading}
                    isSortable
                    defaultSortKey={sort}
                    isDesc={isDesc}
                    style={{ marginTop: 15 }}
                    columns={columns}
                    rows={getFilterResultApplication(rows)}
                    allowResize
                    resizeType={'postApproval'}
                    skipMaxHeight={false}
                />

                {page && (
                    <div style={{ margin: '20px 0' }}>
                        <CustomPagination
                            page={page}
                            pageSize={pageSize}
                            total={total}
                            onPageChange={(page) => {
                                loadList({ page, pageSize });
                                // setSelectedRows([]);
                            }}
                        />
                    </div>
                )}
            </STableContent>
            {displayItem && (
                <div style={{ borderLeft: '1px solid #dcdcdc' }}>
                    <SideBar
                        displayItem={displayItem}
                        setDisplayItem={setDisplayItem}
                        onFullViewShow={(isShow) => setFullViewShow(isShow)}
                    />
                </div>
            )}
        </SLayout>
    );
}
